import { makeStyles } from "tss-react/mui"
import { StandardDialog } from "../../../../shared/components/dialogs/StandardDialog"
import { CircularProgress, Grid, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import { QueryErrorBoundary } from "../../../../core/api/components/QueryErrorBoundary"
import { Suspense } from "react"
import { ChangeUserAccountContent } from "./ChangeUserAccountContent"

const useStyles = makeStyles()(() => ({
    content: {
        minHeight: "20rem",
    },
    title: {
        fontSize: "2.25rem",
        fontWeight: 400,
    },
}))

type ChangeUserAccountDialogProps = {
    open: boolean
    onClose: () => void
}

export const ChangeUserAccountDialog = ({ open, onClose }: ChangeUserAccountDialogProps) => {
    const { classes } = useStyles()

    return (
        <StandardDialog
            open={open}
            onClose={onClose}
            maxWidthProp="md"
            dialogTitle={
                <LocalizedStrict id="change-user-account-dialog-title">
                    <Typography className={classes.title}>Change user account</Typography>
                </LocalizedStrict>
            }
        >
            <QueryErrorBoundary>
                <Suspense
                    fallback={
                        <Grid container alignItems="center" justifyContent="center" className={classes.content}>
                            <CircularProgress size={70} />
                        </Grid>
                    }
                >
                    <ChangeUserAccountContent />
                </Suspense>
            </QueryErrorBoundary>
        </StandardDialog>
    )
}
